import React,{useState,useEffect} from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'react-intersection-observer';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPlay,FiClock,FiTarget,FiZap,FiBarChart3,FiCode,FiCalendar,FiExternalLink,FiMaximize2,FiX,FiSettings,FiLayers,FiCpu,FiMic,FiUsers,FiDatabase,FiBookOpen,FiSmartphone,FiTrendingUp,FiBriefcase,FiGrid,FiMonitor,FiTerminal}=FiIcons;

const Demos=()=> {
const [headerRef,headerInView]=useInView({triggerOnce: true,threshold: 0.1});
const [demosRef,demosInView]=useInView({triggerOnce: true,threshold: 0.1});
const [selectedVideo,setSelectedVideo]=useState(null);
const [isFullscreen,setIsFullscreen]=useState(false);

// ESC key handler 
useEffect(()=> {
const handleKeyDown=(event)=> {
if (event.key==='Escape' && selectedVideo) {
handleCloseVideo();
}
};

// Add event listener when modal is open
if (selectedVideo) {
document.addEventListener('keydown',handleKeyDown);
}

// Cleanup event listener
return ()=> {
document.removeEventListener('keydown',handleKeyDown);
};
},[selectedVideo]);

const demos=[ 
{
icon: FiMonitor,
title: 'VibeCoding Admin Panel',
duration: '3:10',
description: 'VibeCoding Admin Panel is your all-in-one solution for managing products,users,orders,campaigns,and analytics from a single,intuitive dashboard. Instantly track inventory,launch marketing campaigns,and monitor business performance with powerful visualizations and real-time updates. Streamline operations,boost productivity,and keep everything organized in one place.',
videoUrl: 'https://share.cleanshot.com/MX4ch3Zt',
embedUrl: 'https://share.cleanshot.com/MX4ch3Zt/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to VibeCoding Admin Panel dashboard'},
{time: '0:30–1:00',description: 'Product and inventory management features'},
{time: '1:00–1:30',description: 'User management and order tracking'},
{time: '1:30–2:15',description: 'Campaign management and marketing tools'},
{time: '2:15–3:10',description: 'Analytics,visualizations,and real-time updates'} 
],
highlights: ['All-in-one dashboard','Real-time analytics','Campaign management','Inventory tracking'],
tags: ['Admin Panel','Dashboard','Analytics','VibeCoding','Management'],
gradient: 'from-emerald-500 to-cyan-500'
},
{
icon: FiGrid,
title: 'FluxCode Project Management',
duration: '2:45',
description: 'Discover FluxCode,created by VibeCoding—a powerful system designed to bring your ideas to life. With FluxCode,you can easily manage your projects,access a full day board,and fine-tune your settings for maximum flexibility. Watch how you can turn your vision into reality with this comprehensive project management solution.',
videoUrl: 'https://share.cleanshot.com/Lrk5Yr3B',
embedUrl: 'https://share.cleanshot.com/Lrk5Yr3B/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to FluxCode project management system'},
{time: '0:30–1:00',description: 'Project creation and organization features'},
{time: '1:00–1:45',description: 'Full day board interface and task management'},
{time: '1:45–2:15',description: 'Settings customization and flexibility options'},
{time: '2:15–2:45',description: 'Turning vision into reality - deployment workflow'} 
],
highlights: ['Comprehensive project management','Full day board interface','Flexible settings customization','Vision to reality workflow'],
tags: ['Project Management','VibeCoding','Day Board','Settings','Workflow'],
gradient: 'from-indigo-500 to-purple-500'
},
{
icon: FiBriefcase,
title: 'ProjectFlow Management',
duration: '2:30',
description: 'Experience seamless project management with ProjectFlow—built using VibeCoding methodology. Watch our comprehensive demo showcasing intelligent project tracking,automated workflows,and team collaboration features that streamline your entire project lifecycle.',
videoUrl: 'https://share.cleanshot.com/rgnT23Gm',
embedUrl: 'https://share.cleanshot.com/rgnT23Gm/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to ProjectFlow platform and overview'},
{time: '0:30–1:00',description: 'Project creation and team setup workflow'},
{time: '1:00–1:30',description: 'Task management and progress tracking features'},
{time: '1:30–2:00',description: 'Automated notifications and reporting system'},
{time: '2:00–2:30',description: 'Advanced analytics and project insights'} 
],
highlights: ['Seamless project tracking','Automated workflows','Team collaboration','Real-time analytics'],
tags: ['Project Management','VibeCoding','Automation','Collaboration','Analytics'],
gradient: 'from-emerald-500 to-teal-500'
},
{
icon: FiTrendingUp,
title: 'MarketMind Course Demo',
duration: '2:15',
description: 'Unlock powerful marketing strategies with the MarketMind Course! Built using VibeCoding,this sleek landing page features a fast-loading,responsive design and a streamlined video demo to showcase the course\'s value. Perfect for marketers and entrepreneurs looking for results.',
videoUrl: 'https://share.cleanshot.com/X3KYLzPd',
embedUrl: 'https://share.cleanshot.com/X3KYLzPd/embed',
timeline: [ 
{time: '0:00–0:30',description: 'MarketMind Course platform introduction'},
{time: '0:30–0:55',description: 'Landing page design and user experience'},
{time: '0:55–1:25',description: 'Course content structure and marketing strategies'},
{time: '1:25–1:55',description: 'Responsive design and mobile optimization'},
{time: '1:55–2:15',description: 'Call-to-action optimization and conversion features'} 
],
highlights: ['Marketing strategies','Fast-loading design','Responsive layout','Conversion optimization'],
tags: ['Marketing','Course Platform','Landing Page','VibeCoding','Responsive Design'],
gradient: 'from-orange-500 to-red-500'
},
{
icon: FiTerminal,
title: 'Crush AI Coding Assistant',
duration: '2:45',
description: 'This short demo showcases Crush, a powerful AI coding assistant for the command line, making code generation and editing fast and effortless. Experience intelligent code suggestions, automated refactoring, and seamless integration with your development workflow.',
videoUrl: 'https://share.cleanshot.com/7dzHPH9f',
embedUrl: 'https://share.cleanshot.com/7dzHPH9f/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to Crush AI coding assistant'},
{time: '0:30–1:00',description: 'Command line integration and setup'},
{time: '1:00–1:45',description: 'AI-powered code generation and suggestions'},
{time: '1:45–2:15',description: 'Automated refactoring and code optimization'},
{time: '2:15–2:45',description: 'Workflow integration and productivity gains'} 
],
highlights: ['AI-powered code generation','Command line integration','Automated refactoring','Effortless editing'],
tags: ['AI Assistant','Command Line','Code Generation','Development','Productivity'],
gradient: 'from-green-500 to-blue-500'
},
{
icon: FiBookOpen,
title: 'Courses Creator',
duration: '2:45',
description: 'Discover how Courses Creator can transform your workflow! Watch our quick demo to see the app in action and learn how it simplifies course creation. Experience streamlined educational content development with intelligent automation.',
videoUrl: 'https://share.cleanshot.com/7dzHPH9f',
embedUrl: 'https://share.cleanshot.com/7dzHPH9f/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to Courses Creator platform'},
{time: '0:30–1:00',description: 'Course structure and content organization'},
{time: '1:00–1:45',description: 'Automated content generation and templates'},
{time: '1:45–2:15',description: 'Publishing and sharing capabilities'},
{time: '2:15–2:45',description: 'Workflow optimization and time savings'} 
],
highlights: ['Streamlined course creation','Automated content templates','Publishing workflows','Educational content management'],
tags: ['Education','Course Creation','Content Management','Automation','Templates'],
gradient: 'from-green-500 to-emerald-500'
},
{
icon: FiDatabase,
title: 'Business Intelligence Demo',
duration: '2:30',
description: 'Unlock the power of BI—turn raw data into actionable insights. Experience real-time dashboards,interactive reports,and seamless integration—all in one place. See how you can transform your business with powerful data visualization.',
videoUrl: 'https://share.cleanshot.com/NJqGmQPY',
embedUrl: 'https://share.cleanshot.com/NJqGmQPY/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to Business Intelligence platform'},
{time: '0:30–1:00',description: 'Real-time dashboard creation and customization'},
{time: '1:00–1:30',description: 'Interactive reports and data visualization'},
{time: '1:30–2:00',description: 'Seamless integration with existing systems'},
{time: '2:00–2:30',description: 'Advanced analytics and business insights'} 
],
highlights: ['Real-time dashboards','Interactive reports','Seamless integration','Data transformation'],
tags: ['BI','Analytics','Dashboards','Data Visualization','Business Intelligence'],
gradient: 'from-emerald-500 to-blue-500'
},
{
icon: FiUsers,
title: 'Self-Creating Agent System',
duration: '3:15',
description: 'Unlock the power of automation with our self-creating agent system. Our platform builds intelligent agents on the fly—no coding required. Experience cold,efficient,hands-off productivity that adapts to your needs.',
videoUrl: 'https://share.cleanshot.com/zsSjBJmK',
embedUrl: 'https://share.cleanshot.com/zsSjBJmK/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to self-creating agent system'},
{time: '0:30–1:00',description: 'Automated agent creation process'},
{time: '1:00–1:45',description: 'Agent customization and workflow integration'},
{time: '1:45–2:30',description: 'Hands-off productivity demonstration'},
{time: '2:30–3:15',description: 'Real-world use cases and efficiency gains'} 
],
highlights: ['No-code agent creation','Self-adapting workflows','Hands-off automation','Intelligent productivity'],
tags: ['Automation','Agents','No-Code','AI','Productivity'],
gradient: 'from-teal-500 to-green-500'
},
{
icon: FiMic,
title: 'VoiceCode',
duration: '2:45',
description: 'Ready to code at the speed of voice? VoiceCode lets you command,create,and control your environment with simple spoken instructions.',
videoUrl: 'https://share.cleanshot.com/W0rZDmr8',
embedUrl: 'https://share.cleanshot.com/W0rZDmr8/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Introduction to voice-controlled development'},
{time: '0:30–1:00',description: 'Setting up VoiceCode environment'},
{time: '1:00–1:45',description: 'Voice commands for code creation and editing'},
{time: '1:45–2:15',description: 'Advanced voice control features'},
{time: '2:15–2:45',description: 'Productivity gains and workflow integration'} 
],
highlights: ['Voice-controlled coding','Natural language commands','Hands-free development','Real-time code generation'],
tags: ['Voice Control','Development','Productivity','AI','Natural Language'],
gradient: 'from-green-500 to-emerald-500'
},
{
icon: FiCpu,
title: 'Vibe Code System',
duration: '2:15',
description: 'Experience the future of app creation with the Vibe Code System. Watch how simple ideas turn into fully functional applications—no coding required.',
videoUrl: 'https://share.cleanshot.com/hq7tg4Xt',
embedUrl: 'https://share.cleanshot.com/hq7tg4Xt/embed',
timeline: [ 
{time: '0:00–0:25',description: 'Introduction to the Vibe Code System concept'},
{time: '0:25–0:55',description: 'Natural language to application transformation'},
{time: '0:55–1:25',description: 'Real-time app generation and customization'},
{time: '1:25–1:55',description: 'Advanced features and workflow integration'},
{time: '1:55–2:15',description: 'Deployment and sharing capabilities'} 
],
highlights: ['No-code app creation','Natural language processing','Instant deployment','Intuitive workflow design'],
tags: ['No-Code','AI Generation','Workflow','Intuitive','Fast Development'],
gradient: 'from-indigo-500 to-purple-500'
},
{
icon: FiCode,
title: 'Qubirix',
duration: '1:30',
description: 'Instantly generate high-quality frontend,backend,and mobile code from text or images. Includes membership with subscription-based credits.',
videoUrl: 'https://share.cleanshot.com/0lHfZyYt',
embedUrl: 'https://share.cleanshot.com/0lHfZyYt/embed',
timeline: [ 
{time: '0:00–0:20',description: 'Introduction to Qubirix code generation platform'},
{time: '0:20–0:50',description: 'Text-to-code and image-to-code demonstrations'},
{time: '0:50–1:15',description: 'Frontend,backend,and mobile code generation'},
{time: '1:15–1:30',description: 'Subscription model and credit system overview'} 
],
highlights: ['Multi-platform code generation','Text and image inputs','Subscription-based credits','High-quality output'],
tags: ['Code Generation','AI','Frontend','Backend','Mobile','Subscription'],
gradient: 'from-purple-500 to-pink-500'
},
{
icon: FiLayers,
title: 'ApexSpriteAI',
duration: '2:30',
description: 'A sophisticated platform to create,deploy,and manage AI agents. Orchestrate collaborative teams of AI agents for complex tasks.',
videoUrl: 'https://share.cleanshot.com/Z5M2BwJv',
embedUrl: 'https://share.cleanshot.com/Z5M2BwJv/embed',
timeline: [ 
{time: '0:00–0:30',description: 'Platform overview and AI agent architecture'},
{time: '0:30–1:00',description: 'Creating and configuring AI agents'},
{time: '1:00–1:30',description: 'Agent collaboration and team orchestration'},
{time: '1:30–2:00',description: 'Complex task management and workflows'},
{time: '2:00–2:30',description: 'Deployment and monitoring capabilities'} 
],
highlights: ['AI agent creation','Team collaboration','Complex task orchestration','Deployment management'],
tags: ['AI Agents','Collaboration','Orchestration','Productivity'],
gradient: 'from-emerald-500 to-teal-500'
},
{
icon: FiZap,
title: 'SynthWeaver',
duration: '2:00',
description: 'Create diverse synthetic datasets and multimedia content for AI training and simulations. Scale data pipelines with ease.',
videoUrl: 'https://share.cleanshot.com/BJMHCc5k',
embedUrl: 'https://share.cleanshot.com/BJMHCc5k/embed',
timeline: [ 
{time: '0:00–0:15',description: 'Introduction to synthetic data generation'},
{time: '0:15–0:45',description: 'Dataset creation and customization options'},
{time: '0:45–1:15',description: 'Multimedia content generation capabilities'},
{time: '1:15–1:45',description: 'Scaling data pipelines and automation'},
{time: '1:45–2:00',description: 'AI training integration and use cases'} 
],
highlights: ['Synthetic dataset creation','Multimedia content generation','Scalable data pipelines','AI training integration'],
tags: ['Synthetic Data','AI Training','Content'],
gradient: 'from-yellow-500 to-orange-500'
},
{
icon: FiBarChart3,
title: 'DevAI-Powered',
duration: '1:30',
description: 'AI assistant for developers—code suggestions,automated refactoring,and diagnostics to boost productivity and code quality.',
videoUrl: 'https://share.cleanshot.com/s29g1wwF',
embedUrl: 'https://share.cleanshot.com/s29g1wwF/embed',
timeline: [ 
{time: '0:00–0:20',description: 'Developer AI assistant overview'},
{time: '0:20–0:50',description: 'Code suggestions and intelligent completions'},
{time: '0:50–1:15',description: 'Automated refactoring and code diagnostics'},
{time: '1:15–1:30',description: 'Productivity metrics and quality improvements'} 
],
highlights: ['Intelligent code suggestions','Automated refactoring','Code diagnostics','Productivity enhancement'],
tags: ['Developer Tools','AI','Productivity'],
gradient: 'from-blue-500 to-indigo-500'
} 
];

const handleVideoClick=(demo)=> {
setSelectedVideo(demo);
};

const handleCloseVideo=()=> {
setSelectedVideo(null);
setIsFullscreen(false);
};

const toggleFullscreen=()=> {
setIsFullscreen(!isFullscreen);
};

const openVideoInNewTab=(url)=> {
window.open(url,'_blank','noopener,noreferrer');
};

return ( 
<div className="relative">
{/* Animated Background */}
<div className="absolute inset-0 overflow-hidden pointer-events-none">
<div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl animate-float"></div>
<div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent-purple/10 rounded-full blur-3xl animate-float" style={{animationDelay: '2s'}}></div>
</div>

{/* Video Modal with Picture-in-Picture Style */}
{selectedVideo && ( 
<motion.div 
initial={{opacity: 0}}
animate={{opacity: 1}}
exit={{opacity: 0}}
className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
onClick={handleCloseVideo}
>
<motion.div 
initial={{scale: 0.9,opacity: 0,y: 50}}
animate={{scale: 1,opacity: 1,y: 0}}
exit={{scale: 0.9,opacity: 0,y: 50}}
onClick={(e)=> e.stopPropagation()}
className={`relative bg-dark-900/95 backdrop-blur-xl rounded-2xl border border-dark-700/50 overflow-hidden shadow-2xl ${isFullscreen ? 'w-full h-full m-0' : 'w-full max-w-4xl mx-4 max-h-[90vh]'}`}
>
{/* Video Header */}
<div className="flex items-center justify-between p-4 border-b border-dark-700/30">
<div className="flex items-center">
<div className={`inline-flex items-center justify-center w-10 h-10 bg-gradient-to-r ${selectedVideo.gradient} rounded-lg mr-3 shadow-lg`}>
<SafeIcon icon={selectedVideo.icon} className="w-5 h-5 text-white" />
</div>
<div>
<h3 className="text-lg font-bold text-white">{selectedVideo.title}</h3>
<p className="text-gray-400 text-sm">{selectedVideo.duration} demo</p>
</div>
</div>
<div className="flex items-center gap-2">
<button 
onClick={toggleFullscreen}
className="p-2 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-dark-700/50"
title="Toggle fullscreen"
>
<SafeIcon icon={FiMaximize2} className="w-4 h-4" />
</button>
<button 
onClick={()=> openVideoInNewTab(selectedVideo.videoUrl)}
className="p-2 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-dark-700/50"
title="Open in new tab"
>
<SafeIcon icon={FiExternalLink} className="w-4 h-4" />
</button>
<button 
onClick={handleCloseVideo}
className="p-2 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-dark-700/50"
title="Close (ESC)"
>
<SafeIcon icon={FiX} className="w-4 h-4" />
</button>
</div>
</div>

{/* Video Content with Autoplay */}
<div className={`${isFullscreen ? 'h-full' : 'aspect-video'} bg-gradient-to-br from-dark-800 to-dark-900`}>
{selectedVideo.embedUrl ? ( 
<iframe 
src={`${selectedVideo.embedUrl}?autoplay=1`}
className="w-full h-full border-0"
allow="autoplay;fullscreen"
allowFullScreen
title={selectedVideo.title}
/>
) : ( 
<div className="w-full h-full flex items-center justify-center">
<div className="text-center">
<div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-primary-500 to-accent-purple rounded-full mb-4 shadow-lg">
<SafeIcon icon={FiPlay} className="w-8 h-8 text-white ml-1" />
</div>
<p className="text-white text-lg font-medium mb-2">{selectedVideo.title}</p>
<p className="text-gray-400 mb-4">Demo not available for embedding</p>
<motion.button 
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
onClick={()=> openVideoInNewTab(selectedVideo.videoUrl)}
className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-primary-500 to-accent-purple text-white rounded-xl text-sm font-medium hover:from-primary-600 hover:to-accent-purple/90 transition-all duration-300"
>
<SafeIcon icon={FiExternalLink} className="w-4 h-4 mr-2" />
Open Demo Video
</motion.button>
</div>
</div>
)}
</div>

{/* Compact Video Info (only show when not fullscreen) */}
{!isFullscreen && ( 
<div className="p-4 border-t border-dark-700/30 max-h-48 overflow-y-auto">
<p className="text-gray-300 text-sm mb-3">{selectedVideo.description}</p>

{/* Tags */}
<div className="flex flex-wrap gap-1 mb-3">
{selectedVideo.tags.slice(0,4).map((tag,index)=> ( 
<span key={index} className="text-xs bg-primary-500/20 text-primary-300 px-2 py-1 rounded border border-primary-500/30">
{tag}
</span>
))}
</div>

{/* Key Highlights - Compact */}
<div>
<h4 className="text-sm font-semibold text-white mb-2">Key Features</h4>
<div className="grid grid-cols-2 gap-1 text-xs">
{selectedVideo.highlights.slice(0,4).map((highlight,index)=> ( 
<div key={index} className="flex items-center">
<SafeIcon icon={FiTarget} className="w-3 h-3 text-primary-400 mr-1" />
<span className="text-gray-300">{highlight}</span>
</div>
))}
</div>
</div>

{/* ESC Key Hint - Compact */}
<div className="mt-3 p-2 bg-dark-700/30 rounded text-center">
<p className="text-gray-400 text-xs">
Press <kbd className="px-1 bg-dark-600/50 text-gray-300 rounded text-xs">ESC</kbd> to close
</p>
</div>
</div>
)}
</motion.div>
</motion.div>
)}

{/* Header */}
<section ref={headerRef} className="py-24 lg:py-32 relative">
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
<motion.div 
initial={{opacity: 0,y: 20}}
animate={headerInView ? {opacity: 1,y: 0} : {}}
transition={{duration: 0.6}}
className="text-center"
>
<h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-8">
<span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
Interactive Demos
</span>
</h1>
<p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
Explore our cutting-edge AI applications in action. From voice-controlled development to no-code app creation and agent orchestration,see how we're pushing the boundaries of AI technology.
</p>
</motion.div>
</div>
</section>

{/* Demos - Compact Grid Layout */}
<section ref={demosRef} className="py-20 relative">
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
{demos.map((demo,index)=> ( 
<motion.div 
key={index}
initial={{opacity: 0,y: 20}}
animate={demosInView ? {opacity: 1,y: 0} : {}}
transition={{duration: 0.6,delay: index * 0.1}}
whileHover={{y: -5,scale: 1.02}}
className="group bg-dark-800/30 backdrop-blur-sm rounded-2xl overflow-hidden border border-dark-700/30 hover:border-primary-500/30 transition-all duration-300"
>
{/* Video Preview Area - Compact */}
<div 
className="bg-gradient-to-br from-dark-900 to-dark-800 aspect-video flex items-center justify-center relative overflow-hidden cursor-pointer group"
onClick={()=> handleVideoClick(demo)}
>
<div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 to-accent-purple/10 group-hover:from-primary-500/20 group-hover:to-accent-purple/20 transition-all duration-300"></div>

{/* Video Preview Content */}
<div className="text-center relative z-10">
<motion.div 
whileHover={{scale: 1.1}}
whileTap={{scale: 0.95}}
className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full cursor-pointer hover:bg-white/30 transition-all duration-300 border border-white/30 group mb-3"
>
<SafeIcon icon={FiPlay} className="w-6 h-6 text-white ml-1 group-hover:scale-110 transition-transform" />
</motion.div>
<div>
<p className="text-white text-sm font-medium">{demo.title}</p>
<p className="text-white/80 text-xs mb-2">{demo.duration}</p>
<div className="inline-flex items-center px-3 py-1 bg-gradient-to-r from-primary-500/80 to-accent-purple/80 text-white rounded-lg text-xs font-medium group-hover:from-primary-600 group-hover:to-accent-purple/90 transition-all duration-300 backdrop-blur-sm">
<SafeIcon icon={FiPlay} className="w-3 h-3 mr-1" />
Watch Demo
</div>
</div>
</div>
</div>

{/* Demo Details - Compact */}
<div className="p-6">
<div className="flex items-center mb-4">
<div className={`inline-flex items-center justify-center w-10 h-10 bg-gradient-to-r ${demo.gradient} rounded-lg mr-3 shadow-lg`}>
<SafeIcon icon={demo.icon} className="w-5 h-5 text-white" />
</div>
<div>
<h2 className="text-lg font-bold text-white">{demo.title}</h2>
<div className="flex items-center text-gray-400">
<SafeIcon icon={FiClock} className="w-3 h-3 mr-1" />
<span className="text-xs">{demo.duration}</span>
</div>
</div>
</div>

<p className="text-gray-300 text-sm mb-4 line-clamp-3">{demo.description}</p>

{/* Tags - Compact */}
<div className="flex flex-wrap gap-1 mb-4">
{demo.tags.slice(0,3).map((tag,tagIndex)=> ( 
<span key={tagIndex} className="text-xs bg-dark-700/50 text-gray-300 px-2 py-1 rounded border border-dark-600/30">
{tag}
</span>
))}
{demo.tags.length > 3 && ( 
<span className="text-xs text-gray-400">+{demo.tags.length - 3}</span>
)}
</div>

{/* Highlights - Compact */}
<div className="mb-4">
<h3 className="text-sm font-semibold text-white mb-2">Key Features</h3>
<div className="space-y-1">
{demo.highlights.slice(0,2).map((highlight,highlightIndex)=> ( 
<div key={highlightIndex} className="flex items-center">
<SafeIcon icon={FiTarget} className="w-3 h-3 text-primary-400 mr-2" />
<span className="text-gray-300 text-xs">{highlight}</span>
</div>
))}
{demo.highlights.length > 2 && ( 
<p className="text-xs text-gray-400 ml-5">+{demo.highlights.length - 2} more features</p>
)}
</div>
</div>

{/* Watch Demo Button */}
<motion.button 
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
onClick={()=> handleVideoClick(demo)}
className="w-full inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-primary-500 to-accent-purple text-white rounded-lg text-sm font-medium hover:from-primary-600 hover:to-accent-purple/90 transition-all duration-300"
>
<SafeIcon icon={FiPlay} className="w-4 h-4 mr-2" />
Watch Demo
</motion.button>
</div>
</motion.div>
))}
</div>
</div>
</section>

{/* Demo Note */}
<section className="py-16 relative">
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
<div className="bg-dark-800/30 backdrop-blur-sm rounded-3xl p-8 border border-dark-700/30 text-center">
<h3 className="text-lg font-semibold text-white mb-4">About These Demos</h3>
<p className="text-gray-300 mb-6">
These demos showcase real AI applications built with cutting-edge technology. Each application represents innovative approaches to voice-controlled development,no-code creation,AI orchestration,synthetic data generation,and developer productivity.
</p>
<div className="flex flex-col sm:flex-row gap-4 justify-center">
<motion.div whileHover={{scale: 1.05}} whileTap={{scale: 0.95}}>
<Link to="/contact" className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-primary-500 to-accent-purple text-white rounded-2xl font-medium hover:shadow-2xl hover:shadow-primary-500/25 transition-all duration-300">
Request Custom Demo
</Link>
</motion.div>
<motion.div whileHover={{scale: 1.05}} whileTap={{scale: 0.95}}>
<a href="https://github.com/guychenya" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-dark-800/50 backdrop-blur-sm border border-dark-700/50 text-white rounded-2xl font-medium hover:bg-dark-700/50 hover:border-primary-500/50 transition-all duration-300">
View Source Code
</a>
</motion.div>
</div>
</div>
</div>
</section>

{/* CTA Section */}
<section className="py-24 relative">
<div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 via-accent-purple/10 to-accent-cyan/10 blur-3xl"></div>
<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
<div className="bg-dark-800/30 backdrop-blur-xl rounded-4xl p-12 border border-dark-700/30">
<h2 className="text-4xl lg:text-5xl font-bold mb-6">
<span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
Ready to Build Your AI Solution?
</span>
</h2>
<p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
Let's discuss how we can build a custom AI application tailored to your specific needs and requirements
</p>
<motion.div whileHover={{scale: 1.05}} whileTap={{scale: 0.95}}>
<Link to="/contact" className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-primary-500 to-accent-purple text-white rounded-2xl font-semibold hover:shadow-2xl hover:shadow-primary-500/25 transition-all duration-300">
<SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2" />
Start Your AI Project
</Link>
</motion.div>
</div>
</div>
</section>
</div>
);
};

export default Demos;